import React from 'react';
import { initializeContext } from '~/common/bn-context/bn-context';
import { validateStateReducerWrapper } from '~/common/bn-context/bn-context-helpers';

const initialState = {
  editMode: false,
  highlightOn: false,
  selectedKey: undefined,
  apiRoot: undefined,
};

const translationsEditReducer = {
  'toggle-edit-mode': (state) => {
    const newEditMode = !state.editMode;
    return {
      ...state,
      editMode: newEditMode,
    };
  },
  'toggle-highlight': (state) => {
    const newHighlightOn = !state.highlightOn;
    return {
      ...state,
      highlightOn: newHighlightOn,
    };
  },
  'change-selected-key': (state, action) => {
    return {
      ...state,
      selectedKey: action.translationKey ?? undefined,
    };
  },
};

const defaultHandler = (state, action) => {
  const developerErrorMessage = `An action was dispatched which matches no known action type: ${action.type}`;
  console.error(developerErrorMessage);
  return { ...state, developerErrorMessage };
};

const { BnContextProvider, createReducer, useContextDispatch, useContextStateSelector } = initializeContext();
export const useTranslationsEditContextSelector = useContextStateSelector;

const reducer = createReducer(translationsEditReducer, defaultHandler, initialState);
const validatedReducer = validateStateReducerWrapper(reducer, initialState);

export function TranslationsEditProvider({ children, apiRoot }) {
  const initialStateWithApiRoot = { ...initialState, apiRoot };
  return <BnContextProvider reducer={validatedReducer} initialState={initialStateWithApiRoot}>{children}</BnContextProvider>;
}

export function useToggleEditMode() {
  const dispatch = useContextDispatch();

  return () => dispatch({ type: 'toggle-edit-mode' });
}

export function useToggleHighlight() {
  const dispatch = useContextDispatch();

  return () => dispatch({ type: 'toggle-highlight' });
}

export function useChangeSelectedKey() {
  const dispatch = useContextDispatch();

  return (translationKey) => dispatch({ type: 'change-selected-key', translationKey });
}
